<template>
   <div id="main-div" class="p-2">
      <b-row>
         <b-col md="auto">
            <div class="card">
               <div class="card-body">
                  <b-row>
                  <h3>ORM Object Editor</h3>
                  </b-row>
                  <span id="span-dump" class="mono"></span><!-- used to measure text lengths  -->
                  <!-- b-row class="pb-2">
                     <b-col md="auto"><b-input v-model="className" size="sm" placeholder="Class Name"></b-input></b-col>
                     <b-col md="auto"><b-button @click="importFromHeader()" size="sm">imp</b-button></b-col>
                     <b-col md="auto"><b-button @click="generate()" size="sm">gen</b-button></b-col>
                  </b-row -->
                  <b-row>
                     <b-button-group size="sm">
                        <b-input v-model="className" size="sm" placeholder="Class Name"></b-input>
                        <b-button @click="importFromHeader()" size="sm" style="background-color: rgb(123 165 136);">import</b-button>
                        <b-button @click="generate()" size="sm" variant="outline-secondary">generate</b-button>
                     </b-button-group>
                  </b-row>
                  <b-row class="pt-2">
                     <b-list-group>
                        <b-list-group-item
                           v-for="member in members"
                           :key="member.id"
                           class="pt-0 pb-0 px-0"
                        >
                           <b-button-group size="sm">
                              <b-button disabled class="mono"><span v-if="member.id < 10">0</span>{{ member.id }}</b-button>
                              <b-button
                                 
                                 :disabled="editInProgress"
                                 @click="removeMemeber(member)"
                                 style="background-color: #c1cec1;"
                              ><span class="icon icon-bin" /></b-button>
                              <b-button
                                 :id="`button-actions-popover-${member.id}`"
                                 :disabled="editInProgress"
                                 class="mono"
                                 href="#"
                                 tabindex="0"
                                 @click="editInProgress = true"
                                 variant="outlint-secondary"
                                 :style="{
                                    'max-width': `${typeTextWidth}px`,
                                    'min-width': `${typeTextWidth}px`,
                                    'text-align': 'left',
                                    'background-color': '#e0949c',
                                    'color': 'white'
                                 }"
                                 >{{ member.type }}</b-button
                              >

                              <!-- div v-bind:style="{ color: activeColor, fontSize: fontSize + 'px' }"></div -->

                              <b-popover
                                 :target="`button-actions-popover-${member.id}`"
                                 triggers="focus"
                              >
                                 <b-button-group vertical>
                                    <b-button
                                       v-for="type in types"
                                       :key="type"
                                       @click="changeType(member, type)"
                                       variant="outline-secondary"
                                       >{{ type }}</b-button
                                    >
                                 </b-button-group>
                              </b-popover>
                              <b-input
                                 v-if="editInProgress && member.id == editNameMemberId"
                                 v-model="member.name"
                                 @keypress.enter="editInProgress = false; generate()"
                                 :style="{ 'text-width': '100px' }"
                                 size="sm"
                                 block
                                 variant="primary-outline"
                              ></b-input>

                              <b-button
                                 v-else
                                 block
                                 :disabled="editInProgress"
                                 @click="editInProgress = true; editNameMemberId = member.id;"
                                 style="background-color: rgb(174 167 214);"
                                 >{{ member.name }}</b-button
                              >
                           </b-button-group>
                        </b-list-group-item>
                        <b-list-group-item>
                           <b-button size="sm" variant="success" @click="addMember"><span class="icon icon-plus"/></b-button>
                        </b-list-group-item>
                     </b-list-group>
                  </b-row>
               </div>
            </div>
         </b-col>
         <b-col class="pl-0">
            <div id="output-card">
               <div class="card">
                  <div class="card-body row">
                     <b-col class="pr-0">
                        <b-overlay :show="queryInProgress" rounded="sm">
                           <h4 v-if="className && className.length > 0">{{className}}.h</h4>
                           <b-textarea 
                              v-model="headerOutput"
                              rows="3"
                              max-rows="60"
                              class="code"
                              size="sm"
                           ></b-textarea>
                        </b-overlay>
                     </b-col>
                     <b-col class="pl-0">
                         <b-overlay :show="queryInProgress" rounded="sm">
                            <h4 v-if="className && className.length > 0">{{className}}.cpp</h4>
                           <b-textarea
                              v-model="bodyOutput"
                              rows="3"
                              max-rows="60"
                              class="code"
                              size="sm"
                              no-resize
                           ></b-textarea>
                         </b-overlay>
                     </b-col>
                  </div>
               </div>
            </div>
         </b-col>
      </b-row>
      <b-modal v-model="importHeaderModalState" title="paste header here">
         <span>or only paste the class members</span>
         <b-textarea v-model="headerData"></b-textarea>
      </b-modal>
   </div><!-- main-div -->
</template>
<style>
   .mono {
      font-family: 'Lucida Console', monospace !important;
   }
   .code {   
      font-family: 'Lucida Console', monospace !important;
      background-color: #1d2021 !important;
      color: #fabd2f !important;
      outline: none !important;
      resize: none !important;
      white-space: nowrap !important;
      overflow: auto !important;
   }

   

</style>
<script>
export default {
   name: "orm-object-editor",
   data() {
      return {
         shouldAutoGenerate: true,
         queryInProgress: false,
         className: "",
         headerOutput: "",
         bodyOutput: "",
         editInProgress: false,
         editNameMemberId: null,
         headerData: "",
         importHeaderModalState: false,
         memberCounter: 0,
         members: [ ],
         typeAliases: { string: "std::string" },
         types: [ 
            "int"
          , "double"
          , "std::string"
          , "bool"
          , "time_t"
         ],
         typeAttributes: {
            int:           { orNullMethodName: "getNewIntOrNull"     }
          , double:        { orNullMethodName: "getNewStringOrNull"  }
          , 'std::string': { orNullMethodName: "getNewStringOrNull"  }
          , bool:          { orNullMethodName: "getNewBoolOrNull"    }
          , time_t:        { orNullMethodName: "getNewTimeTOrNull"   }
         },
         typeTextWidth: 50 // constant button width in px for types, set in the beginning.
      };
   },
   watch: {
      headerData: function (n, o) {
         if (n.length > 0) {
            this.parseHeaderData();
            this.importHeaderModalState = false;
            this.headerData = "";
            this.$bvToast.toast("parsed header data", {
               title: "ORM Object Editor",
               autoHideDelay: 2500,
               appendToast: false,
            });
         }
      },
   },
   methods: {
      clamp(x, min, max) {
         return Math.min(Math.max(x, min), max);
      },
      addMember() {
         this.members.push({ id: this.memberCounter++, name: "", type: this.types[0]});
         this.editInProgress = false;
         if(this.shouldAutoGenerate) this.generate();
      },
      removeMemeber(member) {
         // console.log("+++ removeMember");
         // console.log(this.members.indexOf(member));
         this.editInProgress = false;
         this.members.splice(this.members.indexOf(member), 1);
         if(this.shouldAutoGenerate) this.generate();
      },
      changeType(member, type) {
         this.members.find((other) => other.id == member.id).type = type;
         this.editInProgress = false;
         this.$root.$emit("bv::hide::popover"); // hides all popovers, indep. of id etc.
         if(this.shouldAutoGenerate) this.generate();
      },
      importFromHeader() {
         this.importHeaderModalState = true;
         //console.log(document.getElementById("span-dump").clientWidth);
      },
      parseHeaderData() {
         console.log(" +++ called importFromHeader");
         console.log(this.headerData);
         const pattern = {
            member: new RegExp("^[' ', '\\t']*(int|std::string|double|bool)*[' ', '\\t']*\\*[' ', '\\t']*[a-z][a-z,A-Z,0-9]*;"),
             class: new RegExp( "class [A-Z][a-z,A-Z,0-9]* *: *public Object<[a-z,A-Z,0-9]*>" )
         };
         let lines = this.headerData.split("\n");
         this.memberCounter = 0;
         this.members = [];
         this.className = "";
         let foundClass = false;
         for (const line of lines) {
             if(!pattern.member.test(line)) console.log("line: '" + line + "' doesnt match.");
            if (pattern.member.test(line)) {
               let dump = line.split("*").map((x) => x.trim());
               console.log("dump", dump);
               this.members.push({
                  id: this.memberCounter++,
                  type: dump[0],
                  name: dump[1].substr(0, dump[1].length - 1),
               });
            } else if (!foundClass && pattern.class.test(line)) {
               foundClass = true;
               // very ugly way of extracting the className from the line,
               // if you can do it more eloquently, then be my guest.
               this.className = line.split("class")[1].split(":")[0].trim()
            }
         }
         // console.log("this.members: ", this.members);
         if(this.shouldAutoGenerate) this.generate();
      },
      format() {
         this.queryInProgress = true;
         axios.post("/ormobjecteditor/format_code", { header: this.headerOutput, body: this.bodyOutput })
         .then( r => {
            this.queryInProgress = false;
            console.log(r);
            this.headerOutput = r.data.header//.split("\n");
            this.bodyOutput   = r.data.body//.split("\n");
            console.log(r);
         }).catch(e => { 
            console.error(e);
            alert("shit went wrong.");
            this.queryInProgress = false;
         });
      },
      generate() {
         this.generateHeader();
         this.generateBody();
         this.format();
      },
      generateBody() {

         const constructor =  this.members.map( m => `${m.name} = nullptr;`).join('\n');
         const safeDelete = this.members.map( m => `SAFE_DELETE(${m.name});` ).join("\n");
         const populate =  this.members.map( m => `${m.name} = ${this.typeAttributes[m.type].orNullMethodName}("${m.name}", rs);` ).join("\n");
         let gettersAndSetters = "";

         for(let member of this.members) {
            const capitalizedName = member.name.charAt(0).toUpperCase() + member.name.slice(1);
            const capitalizedType = member.type.charAt(0).toUpperCase() + member.type.slice(1);//TODO bugged


            switch(member.type) {
               case "int":
               case "double":
               case "time_t":
                  gettersAndSetters+=`${member.type} ${this.className}::get${capitalizedName}(){
                     return IS_NULL(${member.name}) ? 0 : *${member.name};
                  }
                  void ${this.className}::set${capitalizedName}(${member.type} v){
                     safeNew<${member.type}>(&${member.name});
                     *${member.name} = v;
                     change${capitalizedType}("${member.name}", v);
                  }
                  bool ${this.className}::is${capitalizedName}Null(){
                     return IS_NULL(${member.name});
                  }
                  void ${this.className}::set${capitalizedName}Null(){
                     SAFE_DELETE(${member.name});
                     changeToNull("${member.name}");
                  }\n\n`
               break;
               case "string":
               case "std::string":
                  gettersAndSetters+=`std::string ${this.className}::get${capitalizedName}(){
                     return IS_NULL(${member.name}) ? "" : *${member.name};
                  }
                  void ${this.className}::set${capitalizedName}(std::string v){
                     safeNew<std::string>(&${member.name});
                     *${member.name} = v;
                     changeString("${member.name}", v);
                  }
                  bool ${this.className}::is${capitalizedName}Null(){
                     return IS_NULL(${member.name});
                  }
                  void ${this.className}::set${capitalizedName}Null(){
                     SAFE_DELETE(${member.name});
                     changeToNull("${member.name}");
                  }\n\n`
               break;
               case "bool":
                 gettersAndSetters+=`bool ${this.className}::get${capitalizedName}() {
                     return IS_NULL(${member.name}) ? 0 : *${member.name};
                  }

                  void ${this.className}::set${capitalizedName}(bool v){
                     safeNew<bool>(&${member.name});
                     *${member.name} = v;
                     changeBool("${member.name}", v);
                  }

                  bool ${this.className}::is${capitalizedName}Null(){
                     return IS_NULL(${member.name});
                  }

                  void ${this.className}::set${capitalizedName}Null(){
                     SAFE_DELETE(${member.name});
                     changeToNull("${member.name}");
                  }\n\n`
               break;

            }


         }

         this.bodyOutput = `#include "${this.className}.h"
            namespace ORM{
            ${this.className}::${this.className}() {
               ${constructor}
            }

            ${this.className}::${this.className}(sql::ResultSet *rs) { this->populate(rs); }

            ${this.className}::~${this.className}()
            {
               ${safeDelete}
            }

            void ${this.className}::populate(sql::ResultSet *rs) {
               ${populate}
               exists = true;
            }

            ${gettersAndSetters}

            } // namespace ORM
         `;

      },
      generateHeader() 
      {
         let publicMembers = "";
         let gettersAndSetters = "";
         console.log("before the loop");
         for(let member of this.members)
         {
            const capitalizedName = member.name.charAt(0).toUpperCase() + member.name.slice(1);
            publicMembers += `${member.type}* ${member.name};\n`;
            console.log("fack", publicMembers);
            gettersAndSetters +=`${member.type} get${capitalizedName}();
               void set${capitalizedName}(${member.type} v);
               bool is${capitalizedName}Null();
               void set${capitalizedName}Null();\n\n`
         }

    this.headerOutput = `#pragma once
   #include "Object.h"
   namespace ORM 
   {
      class ${this.className}: public Object<${this.className}>
      {
       private:
         ${publicMembers}
       public:
          ${this.className}();
          ${this.className}(sql::ResultSet* rs);
         ~${this.className}();
         void populate( sql::ResultSet* rs );

         ${gettersAndSetters}
      };
      typedef SPTR(${this.className}) SP${this.className};
      typedef SPTR_VECT_SPTR(${this.className}) SPVSP${this.className};
   }`;

      }
   },
   mounted() {
      console.log("mounted.");
      let spanDump = document.getElementById("span-dump");
      console.log(spanDump);
      spanDump.innerText = this.types.sort(
         (v, w) => -1 * this.clamp(v.length - w.length, -1, 1)
      )[0];
      this.typeTextWidth = 12 + Math.ceil(spanDump.getBoundingClientRect().width);
      spanDump.style="display:none";
   },
   created() {},
};
</script>

<!-- 

      int* id;
      std::string* code;
      std::string* name;
      double* rate;

-->